import React, { useState, useEffect } from 'react';
import { UserProfileModal } from '../Modais/Modal';

function getCookie(nome) {
    var nomeEQ = nome + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)===' ') c = c.substring(1,c.length);
      if (c.indexOf(nomeEQ) === 0) return c.substring(nomeEQ.length,c.length);
    }
    return null;
}

const Config = ({ show, onClose, showToast }) => {
    const [userData, setUserData] = useState(null);
    const [showChangePassword, setShowChangePassword] = useState(false);

    const fetchUserData = async () => {
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/buscar`, {
                method: 'GET',
                headers: {
                    'Authority': token_autorizado,
                },
            });
    
            const result = await response.json();
            
            if (result.status === "ok") {
                setUserData(result.usuario);
            } else {
                showToast(result.mensagem || 'Erro ao carregar dados do usuário', 'error');
            }
        } catch (error) {
            console.error('Erro ao buscar dados do usuário:', error);
            showToast('Erro ao carregar dados do usuário', 'error');
        }
    };

    const handleChangePassword = async (currentPassword, newPassword, callback) => {
        try {
            const token_autorizado = getCookie("info");
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/usuarios/atualizar`, {
                method: 'POST',
                headers: {
                    'Authority': token_autorizado,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    nome: userData.nome,
                    email: userData.email,
                    cargo: userData.cargo,
                    senhaAtual: currentPassword,
                    senhaNova: newPassword,
                    senhaNovaConfirm: newPassword,
                    id: userData.id
                }),
            });
    
            const result = await response.json();
            
            if (result.status === "ok") {
                showToast('Senha alterada com sucesso!', 'success');
                setShowChangePassword(false); // Volta para a view de perfil após sucesso
                callback();
            } else {
                showToast(result.mensagem || 'Erro ao alterar senha', 'error');
            }
        } catch (error) {
            console.error('Erro ao alterar senha:', error);
            showToast('Erro ao alterar senha', 'error');
        }
    };

    const handleBackToProfile = () => {
        setShowChangePassword(false);
    };

    useEffect(() => {
        if (show) {
            fetchUserData();
            setShowChangePassword(false); // Reseta para mostrar o perfil quando o modal é aberto
        }
    }, [show]);

    return (
        <UserProfileModal
            show={show}
            fecharModal={onClose}
            userData={userData}
            handlePasswordChange={handleChangePassword}
            showChangePassword={showChangePassword}
            onShowChangePassword={() => setShowChangePassword(true)}
            onBackToProfile={handleBackToProfile}
            showToast={showToast}
            getCookie={getCookie}
        />
    );
};

export default Config;